import {observer} from "mobx-react";
import React from "react";
import HelpText from "../HelpText";
import stateStore from "./StateStore";
import countryStore from "../Country/CountryStore";

const StateUI = observer( (props) => {

    function onDropDownState() {
        document.getElementById('dropdown_state_list').style.display = 'inline';
    }

    const style = {background: "transparent", outline: "none",
        display: "flex", flexDirection: "column", padding: 0,
        width: '100%', border: '0 solid transparent'}

    const StateList = (elem, index) => {
        return <button key={"state_" + index}
            style={style} type="button" className="dropdown_buttons"
            onMouseDown={() => {stateStore.ChoiceState(elem); props.checkChange()}}
            onKeyDown={(e) => {if(e.key === "Enter"){stateStore.ChoiceState(elem); props.checkChange()}}}>

            <div style={{width: '100%'}}>
                <p className={'dropdown_element'}>{elem}</p>
            </div>
        </button>
    }

    return <div className="dropdown_div">
        <input className={`${props.disabled? "input_test dropdown_img" : "input_test_change dropdown_img_active"} ${stateStore.validState}`} id="dropdown_stat" autoComplete="off"
               disabled={props.disabled} placeholder={"Выберите регион"} type="text"
               style={countryStore.country === "Россия"? {caretColor: "transparent", cursor: "default", width: "100%"} : {width: "100%"}}
               value={stateStore.state}
               onFocus={() => stateStore.FocusState()}
               onKeyDown={(e) => stateStore.KeyDown(e)}
               onChange={(e) => stateStore.setState(e)}
               onClick={() => {onDropDownState()}}
               onBlur={() => stateStore.Blur()}
        />

            <div id="dropdown_state_list" className="dropdown_col_4"
                 style={countryStore.country === "Россия"?
                     {width: "100%", background: "#F5F7FA", overflowY: "scroll", minHeight: "2em",  maxHeight: "10em", display: 'none'}
                     : {display: 'none'}}>
                {stateStore.returnStateList.map((elem, index) => StateList(elem, index))}
            </div>

        <HelpText text={stateStore.HelpText}/>
    </div>
})

export default StateUI;